<template>
  <AppDialog :model-value="modelValue" persistent>
    <v-card>
      <v-card-title>
        <AppIcon icon="mdi:check-bold" color="success" start />
        {{ $tt('form_saved_in_system') }}
      </v-card-title>

      <v-card-text>
        <p class="mb-2">{{ $tt('resume_form_with_link') }}</p>
        <CopyTextField
          :value="url"
          :hint="$tt('link_validity_time')"
          class="mb-6"
          persistent-hint readonly
        />
        <template v-if="emailValid">
          <FormHeading :h="4">
            <AppIcon icon="mdi:email-outline" start />
            {{ $tt('link_send') }}
          </FormHeading>
          <p class="mb-2">{{ $tt('send_link_to_email') }}</p>
          <EmailField :model-value="email" readonly />
        </template>
      </v-card-text>

      <v-card-actions>
        <AppBtn v-if="emailValid" primary :loading="sendLoading" @click="$emit('send')">
          {{ $tt('send_link') }}
        </AppBtn>
        <AppBtn :disabled="sendLoading" @click="modelValue = false">
          {{ $tt('close') }}
        </AppBtn>
      </v-card-actions>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
import { emailRule } from '~/helpers/form-validation';

const modelValue = defineModel<boolean>({ required: true });
const props = defineProps<{
  token: string | null;
  url: string;
  email: string;
  sendLoading: boolean;
}>();

defineEmits(['send']);

const emailValid = computed(() => emailRule(props.email));
</script>

<style scoped>
.v-card-title {
  white-space: break-spaces;
}
</style>